import ExecutionEnvironment from 'exenv';

export const isClient = () => ExecutionEnvironment.canUseDOM;
